/* The form request page (forms-web.html moment 2 A: .reqPage, .reqHead, .reqIntro, .term), in the telify layer. Colors are theme tokens only. */
@layer telify {
  .page {
    width: min(680px, calc(100% - 80px));
    margin: 0 auto;
    padding: 34px 0 72px;
  }

  .back {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 26px;
    font-size: 14px;
    color: var(--text-tertiary);
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
    font-family: inherit;
  }

  .kicker {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--text-tertiary);
  }

  .name {
    margin-top: 10px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 52px;
    line-height: 1.08;
    letter-spacing: -0.015em;
  }

  .intro {
    margin-top: 14px;
    display: grid;
    gap: 10px;
  }

  .kind {
    font-size: 14px;
    color: var(--text-tertiary);
  }

  .desc {
    font-size: 16px;
    line-height: 1.6;
    color: var(--text-secondary);
    max-width: 60ch;
  }

  .anon {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    justify-self: start;
    font-size: 14px;
    color: var(--text-secondary);
  }

  .fields {
    margin-top: 30px;
  }

  .bar {
    margin-top: 34px;
  }

  .submitError {
    margin: 0 0 12px;
    font-size: 14px;
    color: var(--danger);
  }

  .submit {
    width: 100%;
  }

  .end {
    width: min(560px, calc(100% - 40px));
    margin: 0 auto;
    padding: 104px 0 96px;
    text-align: center;
    display: grid;
    justify-items: center;
  }

  .orb {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: var(--accent);
    color: var(--text-on-accent);
  }

  .orb svg {
    width: 26px;
    height: 26px;
    stroke-width: 2.4;
  }

  .endKicker {
    margin-top: 28px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--text-tertiary);
  }

  .endTitle {
    margin-top: 10px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 60px;
    line-height: 1.02;
    letter-spacing: -0.02em;
  }

  .endText {
    margin-top: 16px;
    font-size: 18px;
    line-height: 1.6;
    color: var(--text-primary);
  }

  .endActions {
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  .loading {
    padding: 104px 0;
    text-align: center;
    color: var(--text-tertiary);
  }

  @media (max-width: 1023px) {
    .page {
      width: calc(100% - 32px);
    }

    .name,
    .endTitle {
      font-size: 40px;
    }
  }

  /* web-studio-sites D12: a sent form on a custom site (telify-pages.html .colHead, .formBar and .end): no label above the title
     (Gabriel 2026-10-25), and at 860 pixels the smaller title and full-width buttons. */
  :global(:root[data-custom-site]) .kicker,
  :global(:root[data-custom-site]) .endKicker {
    display: none;
  }

  :global(:root[data-custom-site]) .name {
    margin-top: 18px;
  }

  :global(:root[data-custom-site]) .endTitle {
    margin-top: 26px;
  }

  /* The button after the questions: the form's own 24 pixel gap plus this is the mockup's 40 (.formBar). */
  :global(:root[data-custom-site]) .bar {
    margin-top: 16px;
  }

  @media (max-width: 860px) {
    :global(:root[data-custom-site]) .back {
      margin-bottom: 22px;
    }

    :global(:root[data-custom-site]) .name {
      margin-top: 0;
      font-size: 38px;
    }

    :global(:root[data-custom-site]) .end {
      padding: 56px 0 24px;
    }

    :global(:root[data-custom-site]) .endTitle {
      font-size: 42px;
    }

    :global(:root[data-custom-site]) .endActions > * {
      width: 100%;
    }
  }
}
